import { render, staticRenderFns } from "./SpeceficClientVendorReport.vue?vue&type=template&id=55699f58&scoped=true&"
import script from "./SpeceficClientVendorReport.vue?vue&type=script&lang=js&"
export * from "./SpeceficClientVendorReport.vue?vue&type=script&lang=js&"
import style0 from "./SpeceficClientVendorReport.vue?vue&type=style&index=0&id=55699f58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55699f58",
  null
  
)

component.options.__file = "SpeceficClientVendorReport.vue"
export default component.exports